import axios from 'axios'
const ccapi = process.env.VUE_APP_CCAPI;

async function sendMailNotificationClient(email, title, body, fileUrl) {
  var list_files = []
  if(fileUrl != ""){
    list_files.push({
      name: "solicitud_actualizacion_beneficiarios.pdf",
      file: fileUrl
    })
  }
  
  return await axios.post(ccapi + "/send_mail", {
    business: "fas",
    mail:{
      business: "fas",
      process_type:"envio documentos",
      title: title,
      body_mail: encryptMessage(body),
      mailing_list:[email],
      attachment_list:list_files
    }
  },
  {
      'Content-Type': 'application/json'
  })
  .then(response => {
    return response;
  }).catch(error => {
    throw error;
  });
}

function encryptMessage (body) {
  const header = { "alg": "HS256", "typ": "JWT" }
  const encodedHeader = Buffer.from(JSON.stringify(header)).toString('base64')

  var data = {
    "html": body
  }

  const encodedPayload = Buffer.from(JSON.stringify(data)).toString('base64')
  var jwtSecret = "u3E*aWShrxOv";
  const crypto = require('crypto')
  const signature = crypto.createHmac('sha256', jwtSecret).update(encodedHeader + '.' + encodedPayload).digest('base64')      

  return encodedHeader+"."+encodedPayload+"."+signature
}

function validateEmail(email) {
  var regex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
      
  return regex.test(email)
}

function bodyEmailNotificationClient(title, message, urlFas){
  var bodyEmail = `
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;400;500;600;700;800&display=swap" rel="stylesheet">
        <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;400;500;700&display=swap" rel="stylesheet">
        <title>Document</title>
      </head>
      <body style="margin: 0;">
        <div style="text-align: center;height: 50px;background-color: #179099;color: #fff;font-weight:700;">
          <p style="font-family:Poppins,Arial;font-weight: 500;font-size: 28px;text-align: center;margin-top:0px;">FAS</p>
        </div>
        <div style="margin:0 auto;">
          <div class="div_centrado" style="clear: both;margin:0 auto;padding:20px;background:white;width:77%;height:auto;margin-top:40px;border-radius:14px; text-align: center;box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
            <div style="padding-left: 60px;padding-right: 60px;">
              <div>
                <img src="https://cabsacloud.ams3.digitaloceanspaces.com/store/FAS/assets/logo_seccion17.png" alt="" style="float:left;">
              </div>
              <div>
                <img src="https://cabsacloud.ams3.digitaloceanspaces.com/store/FAS/assets/logo_fas.png" alt="" style="float:right;">
              </div>
            </div>
            <p style="padding-left: 60px;padding-right: 60px;margin-top:100px;font-family:Poppins,Arial;font-size:32px;color:#000;font-weight:600;">
              ${title}
            </p>
            
            <p style="padding-left: 60px;padding-right: 60px;margin-top: 70px;font-family:Roboto,Arial;color:#000;text-align: center;font-size:22px;font-weight:400;">
              ${message}
            </p>
            
            <p style="margin-top:70px;">
              <a href="${urlFas}">
                <input type="button" value="Aceptar" style="text-decoration:none;
                font-family:Roboto, Arial;
                font-size: 13px;
                color:#FFFFFF;
                padding-top:7px;
                padding-bottom:7px;
                padding-left:35px;
                padding-right:35px;
                background-color:#179099;
                border: 0px solid;
                border-width: 3px;
                border-radius:7px;
                width:250px;" />
              </a>
            </p>
            
            <div style="display: flex;margin-top: 10px;padding-left: 60px;padding-right: 60px;">
              <hr style="width: 100%;margin-top: 40px; border: 1px solid #179099;">
            </div>
            <p style="padding-left: 60px;padding-right: 60px;margin-top: 15px;margin-bottom:2px;font-family:Roboto,Arial;color:#403F3F;text-align: center; font-size: 13px;">
              FAS le ha enviado este mensaje
            </p>
            <a href="${urlFas}" style="font-family:Roboto,Arial;color:rgb(100, 163, 247);text-align: center;margin-top:40px;text-decoration:none;">FAS</a>
          </div>
        </div>
      </body>
    </html>
  `
  return bodyEmail
}

export {
  sendMailNotificationClient,
  encryptMessage,
  validateEmail,
  bodyEmailNotificationClient
}